import { render, staticRenderFns } from "./DimmingDialog.vue?vue&type=template&id=3869b5c4&scoped=true"
import script from "./DimmingDialog.vue?vue&type=script&lang=ts"
export * from "./DimmingDialog.vue?vue&type=script&lang=ts"
import style0 from "./DimmingDialog.vue?vue&type=style&index=0&id=3869b5c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3869b5c4",
  null
  
)

export default component.exports